
export async function yesNo(title: string, question: string): Promise<boolean> {

    return new Promise((resolve) => {

        const form = document.createElement('form');
        form.enctype = "multipart/_form-data";

        form.innerHTML = `
            <h2>${title}</h2>
            <p>${question}</p>
            <div class="buttons"> 
                <button id="form-yes">JA</button>
                <button id="form-no">NEJ</button>
            </div>
        `;


        const yesButton = form.querySelector('#form-yes');
        yesButton?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            form.remove();
            resolve(true);
        });

        const noButton = form.querySelector('#form-no');
        noButton?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            form.remove();
            resolve(false);
        });

        document.body.appendChild(form);
    });
}
